// "My laptop": model picker filter, save / show the visitor's laptop, and a
// "parts for your laptop" rail on the home page.
import { $, $$, api, cardHTML, esc, icon, store, t, toast } from "./util";
import { refreshMotion } from "./motion-lite";
import { syncAddButtons } from "./cart";

const KEY = "darat_mylaptop";

function picker() {
	const box = $("[data-lppick]");
	if (!box) return;
	const input = $("[data-lp-filter]", box), empty = $("[data-lp-empty]", box);
	let series = "";
	const apply = () => {
		const q = (input.value || "").trim().toLowerCase();
		let n = 0;
		$$(".ds-lpitem", box).forEach((a) => {
			const show = (!series || a.dataset.series === series) && (!q || a.dataset.label.includes(q));
			a.hidden = !show; if (show) n++;
		});
		empty.hidden = !!n;
	};
	input.addEventListener("input", apply);
	box.addEventListener("click", (e) => {
		const s = e.target.closest("[data-lp-series]");
		if (!s) return;
		series = s.dataset.lpSeries;
		$$("[data-lp-series]", box).forEach((b) => b.classList.toggle("is-on", b === s));
		apply();
	});
}

function paintMine() {
	const mine = store(KEY);
	$$("[data-mylaptop]").forEach((el) => {
		el.hidden = !mine;
		if (mine) { el.href = `/laptop/${encodeURIComponent(mine.slug)}`; el.querySelector("b").textContent = mine.label; }
	});
	$$("[data-save-laptop]").forEach((b) => {
		const lp = JSON.parse(b.dataset.saveLaptop);
		const on = mine && mine.slug === lp.slug;
		b.classList.toggle("ds-btn--ghost", !!on); b.classList.toggle("ds-btn--primary", !on);
		b.querySelector("span").textContent = on ? t("جهازي المحفوظ ✓", "My laptop ✓") : t("احفظ كجهازي", "Save as my laptop");
	});
}

async function homeRail() {
	const el = $("[data-mylaptop-rail]"), mine = store(KEY);
	if (!el || !mine) return;
	try {
		const res = await api("darat.storefront.api.laptop_parts", { slug: mine.slug, limit: 5 });
		if (!res.items.length) return;
		el.querySelector("[data-mylaptop-title]").textContent = res.label;
		el.querySelector("a.ds-link").href = `/laptop/${encodeURIComponent(mine.slug)}`;
		const grid = el.querySelector("[data-codes-grid]");
		grid.innerHTML = res.items.map(cardHTML).join("");
		el.hidden = false; refreshMotion(grid); syncAddButtons();
	} catch (e) { /* optional section */ }
}

// ---- "Fits your laptop": the codes matched to the saved laptop, cached for a few hours
const CODES = "darat_mylaptop_codes";
let fitSet = null;

async function fitCodes() {
	const mine = store(KEY);
	if (!mine) return null;
	const c = store(CODES);
	if (c && c.slug === mine.slug && Date.now() - c.t < 6 * 3600e3) return new Set(c.codes);
	try {
		const res = await api("darat.storefront.api.laptop_codes", { slug: mine.slug });
		store(CODES, { slug: mine.slug, t: Date.now(), codes: res.codes || [] });
		return new Set(res.codes || []);
	} catch (e) { return c && c.slug === mine.slug ? new Set(c.codes) : null; }
}

function markCards() {
	if (!fitSet || !fitSet.size) return;
	$$(".ds-card[data-code]:not([data-fitmark])").forEach((card) => {
		card.dataset.fitmark = "1";
		if (!fitSet.has(card.dataset.code)) return;
		const media = card.querySelector(".ds-card__media");
		if (media) media.insertAdjacentHTML("beforeend", `<span class="ds-badge ds-badge--fit">${icon("check")} ${t("يناسب جهازك", "Fits your laptop")}</span>`);
	});
}

// product page: green "fits", amber "not confirmed for your laptop", or "save your laptop to check"
function fitBox() {
	const box = $("[data-fitcheck]");
	if (!box) return;
	const mine = store(KEY), code = box.dataset.fitcheck, modelSpecific = box.dataset.models === "1";
	let html = "";
	if (mine && fitSet && fitSet.has(code)) {
		html = `<p class="ds-fit is-yes">${icon("check-circle")}<span><b>${t("يناسب جهازك", "Fits your laptop")}</b> <bdi dir="ltr">${esc(mine.label)}</bdi>
			<small>${t("مشمولة بضمان التوافق: إن لم تركب على جهازك نستبدلها مجاناً.", "Covered by our fit guarantee: free exchange if it doesn't fit your laptop.")} <a href="/returns#fit">${t("التفاصيل", "Details")}</a></small></span></p>`;
	} else if (mine && fitSet && modelSpecific) {
		html = `<p class="ds-fit is-maybe">${icon("alert")}<span><b>${t("لم نتأكد أنها تناسب", "Not confirmed for")}</b> <bdi dir="ltr">${esc(mine.label)}</bdi>
			<small>${t("قارن رقم القطعة المكتوب على قطعتك القديمة، أو اسألنا قبل الطلب.", "Compare the part number on your old part, or ask us before ordering.")} <a href="/part-number">${t("أين أجد الرقم؟", "Where is the number?")}</a></small></span></p>`;
	} else if (!mine && modelSpecific) {
		html = `<p class="ds-fit">${icon("laptop")}<span><b>${t("تأكد أنها تناسب جهازك", "Check it fits your laptop")}</b>
			<small>${t("اختر موديل جهازك واحفظه، ونعلّم لك القطع المناسبة له في كل المتجر.", "Pick and save your laptop model, and we mark the parts that fit it across the store.")} <a href="/laptop">${t("اختر جهازك", "Choose your laptop")}</a></small></span></p>`;
	}
	box.innerHTML = html;
	box.hidden = !html;
}

async function paintFits() {
	fitSet = await fitCodes();
	markCards(); fitBox();
}

export function initLaptop() {
	picker(); paintMine(); homeRail(); paintFits();
	// cards rendered later (shop filters, rails, search) get their badge too
	let pending = false;
	new MutationObserver(() => {
		if (pending || !fitSet) return;
		pending = true;
		requestAnimationFrame(() => { pending = false; markCards(); });
	}).observe(document.body, { childList: true, subtree: true });
	document.addEventListener("click", (e) => {
		const b = e.target.closest("[data-save-laptop]");
		if (!b) return;
		const lp = JSON.parse(b.dataset.saveLaptop), mine = store(KEY);
		if (mine && mine.slug === lp.slug) { store(KEY, null); toast(`<span>${t("تمت إزالة جهازك المحفوظ", "Removed your saved laptop")}</span>`); }
		else { store(KEY, lp); toast(`${icon("check-circle")}<span>${t("تم حفظ جهازك", "Laptop saved")} — ${esc(lp.label)}</span>`); }
		paintMine();
		$$("[data-fitmark]").forEach((c) => { delete c.dataset.fitmark; c.querySelector(".ds-badge--fit")?.remove(); });
		paintFits();
	});
}
